<template>
  <div class="metadata-drawer-launcher">
    <button
      type="button"
      title="Open metadata drawer"
      aria-label="Open metadata drawer"
      @click="setActiveComponent('plugin')"
    >
      <b-icon icon="info-circle-fill" aria-hidden="true"></b-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: 'MetadataDrawerMain',
  methods: {
    setActiveComponent(component) {
      this.$emit('setActiveComponent', component);
    },
  },
};
</script>

<style scoped>
.metadata-drawer-launcher {
  position: fixed;
  right: 34px;
  bottom: 112px;
  z-index: 9999;
}

.metadata-drawer-launcher button {
  width: 46px;
  height: 46px;
  border: 0;
  border-radius: 50%;
  background: #007d53;
  color: #fff;
  box-shadow: 0 10px 22px rgba(0, 83, 56, 0.25);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.metadata-drawer-launcher button:hover {
  background: #006745;
  transform: translateY(-1px);
}

.metadata-drawer-launcher button:focus {
  outline: 3px solid rgba(0, 125, 83, 0.25);
  outline-offset: 3px;
}
</style>
